import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { useT } from "../../shared/i18n";

/** Deletion confirmation for a container, warning when it has children. */
export function ConfirmDeleteDialog({
  open,
  childrenCount,
  onClose,
  onDelete,
}: {
  open: boolean;
  childrenCount: number;
  onClose: () => void;
  onDelete: () => void;
}) {
  const t = useT();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t("deleteConfirmTitle")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {childrenCount > 0
            ? t("deleteConfirmChildren", { count: String(childrenCount) })
            : t("deleteConfirmBody")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("cancel")}</Button>
        <Button color="error" variant="contained" onClick={onDelete}>
          {t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}